import { service } from '@ember/service';
import Component from '@glimmer/component';
import { type Signature as ProviderSig } from 'parog-web/components/forc/provider';
import type SemeiaSessionService from 'parog-web/services/session';
interface Signature {
  Args: {
    form: ProviderSig['Blocks']['content'][0];
    labelName?: string | undefined;
    placeholder?: string;
    propertyName: string;
  };
}

export default class PublicCommentComponent extends Component<Signature> {
  @service declare session: SemeiaSessionService;

  <template>
    <@form.TextArea
      @displaySubText={{if this.session.medic true}}
      @subText='Ces informations sont partagées avec le patient.'
      @labelName={{@labelName}}
      @propertyName={{@propertyName}}
      @placeholder={{@placeholder}}
    />
  </template>
}
